import React from 'react'

export const HubTableTitle = ({children, ...rest}) => {
  return (
      <h6 {...rest}>{ children }</h6>
  )
}
